/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckHealthResponse
 */
export interface CheckHealthResponse {
    /**
     * 
     */
    healthy: boolean;
}

/**
 * Check if a given object implements the CheckHealthResponse interface.
 */
export function instanceOfCheckHealthResponse(value: object): value is CheckHealthResponse {
    if (!('healthy' in value) || value['healthy'] === undefined) return false;
    return true;
}

export function CheckHealthResponseFromJSON(json: any): CheckHealthResponse {
    return CheckHealthResponseFromJSONTyped(json, false);
}

export function CheckHealthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckHealthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'healthy': json['healthy'],
    };
}

export function CheckHealthResponseToJSON(json: any): CheckHealthResponse {
    return CheckHealthResponseToJSONTyped(json, false);
}

export function CheckHealthResponseToJSONTyped(value?: CheckHealthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthy': value['healthy'],
    };
}

